/*
 *
 * Basic Theme
 *
 */
import "simplelightbox/dist/simple-lightbox.min.css";
import "./scss/style.scss";

import "./js/header";
import "./js/menu-main";
import "./js/accordion";
import "./js/shareOn";
import "./js/load-more";
import "./js/back-to-top";
import "./js/date-dropdown";
import "./js/gallery";

import "./js/front-blocks/news_list/news-list.js";

import "./js/icons/svgxuse.min.js";
require.context("./images", true);
